import i18n from "../i18n"

export default function localizeDate(date: Date): string {
  return new Intl.DateTimeFormat(i18n.language, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date)
}
